export const permissionsEnergyContractFull = [
  "energy-contracts-full",
  "everything-full",
];
